import { render } from "./AllDevicePage.vue?vue&type=template&id=767a6914&ts=true"
import script from "./AllDevicePage.vue?vue&type=script&lang=ts"
export * from "./AllDevicePage.vue?vue&type=script&lang=ts"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/Zalo/CheckDB130_FE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__